const colors = {
  //solids
  black: "#000000",
  white: "#FFFFFF",
  base100: "#F1F6FE",

  //Rich Black
  black50: "#EBEBEB",
  black100: "#cccccc",
  black200: "#adadad",
  black300: "#8f8f8f",
  black400: "#707070",
  black500: "#575757",
  black600: "#525252",
  black700: "#333333",
  black800: "#111111",

  //RRE Blue
  blue10: "#F1F6FE",
  blue50: "#BED5FE",
  blue100: "#A0C1FE",
  blue200: "#89B1FE",
  blue300: "#6C9DFE",
  blue400: "#1965FE",
  blue500: "#1041A2",
  blue600: "#0D3482",
  blue700: "#0A2A68",
  blue800: "#082253",

  // Destructive Red
  red300: "#B80000",
  red400: "#E50000",
  red500: "#FF3333",

  // Gradients
  darkBlueGradient: `linear-gradient(180deg, #1965FE 0%, #0D3482 100%);`,
  lightBlueGradient: `linear-gradient(180deg, #1965FE 0%, rgba(25, 101, 254, 0) 100%);`,

  //Transparents
  blackModalBG: "#00000098",
  darkGridLine: "rgba(255,255,255,0.07)",
  lightGridLine: "rgba(0,0,0,0.1)",

  /**
   * @deprecated
   * in the rare event that you need this color, use base100
   */
  mainBG: "#F1F6FE",
}

export default colors
